/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("BasemapInstance");function t(t){return null!=t&&"object"==typeof t&&n in t}export{n as BasemapSymbol,t as isBasemap};
